import { createApi } from "@reduxjs/toolkit/query/react";

import { axiosBaseQuery } from "@/api/base";
import { Userdata } from "@/types/user";

const TAG = "users-admin";
const TAG_DETAILS = "users-details";
const TAG_SEARCH = "users-search";

interface UserPayload {
  username: string;
  password: string;
  name: string;
  surname: string;
  email: string;
  phone_number: string;
  avatar: string;
  is_active: boolean;
  id?: string;
}

const parsePayload = (payload: UserPayload) => ({
  ...payload,
  password: payload.password || undefined,
  avatar: payload.avatar || undefined,
  id: undefined,
});

export const usersAdminApi = createApi({
  baseQuery: axiosBaseQuery({ baseUrl: "/pf-auth/" }),
  reducerPath: "usersAdminApi",
  tagTypes: [TAG, TAG_DETAILS, TAG_SEARCH],
  endpoints: builder => ({
    createOrUpdateUser: builder.mutation<void, UserPayload>({
      invalidatesTags: [TAG],
      query: user => ({
        url: user.id ? `users/${user.id}` : "users",
        method: user.id ? "PATCH" : "POST",
        data: parsePayload(user),
      }),
    }),
    getUser: builder.query<Userdata, string>({
      providesTags: [TAG_DETAILS],
      transformResponse: (response: Userdata[]) => response[0],
      query: user => ({
        url: "users",
        params: {
          users: user,
        },
      }),
    }),
    searchUsers: builder.query<Userdata[], string>({
      providesTags: [TAG_SEARCH],
      query: query => ({
        url: "users",
        params: {
          query,
        },
      }),
    }),
    getUsers: builder.query<Userdata[], string[] | undefined | void>({
      providesTags: [TAG],
      query: users => ({
        url: "users",
        params: {
          users: users ? users.join(",") : undefined,
        },
      }),
    }),
  }),
});

export const { useGetUsersQuery, useCreateOrUpdateUserMutation, useGetUserQuery, useLazySearchUsersQuery } =
  usersAdminApi;
